import { getCurrentPortal } from '@/shared/utils/portal';
import { PortalTypeEnum } from '@/types/closinglock.types';
import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

const getAmplitudeKey = () => {
    const portal = getCurrentPortal();

    if (portal === PortalTypeEnum.CLIENT) {
        return import.meta.env.VITE_CLIENT_PORTAL_AMPLITUDE_KEY;
    }

    return import.meta.env.VITE_COMPANY_PORTAL_AMPLITUDE_KEY;
};

const CURRENT_API_KEY = getAmplitudeKey();

const addSessionReplay = () => {
    const isIndexedDBSupported = 'indexedDB' in window && 'IDBFactory' in window && 'IDBKeyRange' in window;
    const sessionReplayTracking = sessionReplayPlugin();

    if (isIndexedDBSupported) {
        amplitude.add(sessionReplayTracking);
        amplitude.logEvent('session_replay_status', { enabled: true, reason: 'indexedDB supported' });
    } else {
        amplitude.logEvent('session_replay_status', { enabled: false, reason: 'indexedDB not supported' });
    }
};

if (CURRENT_API_KEY) {
    const config = {
        autocapture: {
            sessions: true,
            autocapture: true,
            elementInteractions: true,
        },
    };

    addSessionReplay();

    amplitude.init(CURRENT_API_KEY, window.options?.currentUser?.email, config);
}

window.amplitude = amplitude;
